import React from 'react'

function Home() {
  return (
    <div className='home'>
        <h1>Welcome to Bot Hunting 🤖</h1>
        <p className='para'>Assemble your team and prepare for battle!</p>
    </div>
  )
}

export default Home
